import { createContext, useCallback, useContext, useRef, useState, type ReactNode } from 'react';
import { IconDone } from '@/shared/icons';

interface ToastCtx {
  toast: (msg: string) => void;
}

const Ctx = createContext<ToastCtx | null>(null);

export function useToast() {
  const c = useContext(Ctx);
  if (!c) throw new Error('useToast must be used within ToastProvider');
  return c.toast;
}

/* Дизайны Toast — доод төвд хар pill (нэг зэрэг нэг л мессеж) */
export function ToastProvider({ children }: { children: ReactNode }) {
  const [msg, setMsg] = useState<string | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const toast = useCallback((m: string) => {
    setMsg(m);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setMsg(null), 2600);
  }, []);

  return (
    <Ctx.Provider value={{ toast }}>
      {children}
      {msg && (
        <div className="fixed bottom-20 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 bg-slate-900 text-white text-sm font-medium rounded-full px-4 py-2.5 shadow-lg whitespace-nowrap">
          <IconDone size={17} className="text-emerald-400" />
          {msg}
        </div>
      )}
    </Ctx.Provider>
  );
}
